import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import LinkButton from './LinkButton';

const Home = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  // Standardized styles
  const styles = {
    h1: {
      fontSize: '3.0rem',
      marginBottom: '2rem',
      fontWeight: '750',
      width: '40rem',
      color: '#2c3e50'
    },
    h2: {
      fontSize: '2.5rem',
      marginBottom: '2rem',
      fontWeight: '700',
      color: '#2c3e50'
    },
    h3: {
       fontSize: '1.5rem',
      marginBottom: '1rem',
      fontWeight: '750',
      color: '#2c3e50'
    },
    paragraph: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      color: '#495057',
      marginBottom: '1.5rem'
    },
    paragraphLast: {
      fontSize: '1.5rem',
      lineHeight: '1.8',
      color: '#495057',
      marginBottom: '2rem'
    },
    section: {
      marginTop: '5rem'
    }
  };

  const faqs = [
    {
      question: "Is there any AI tools I should buy?",
      answer: "You really don't need separate products marketed as \"ChatGPT but for college admissions\" or \"ChatGPT but for studying.\" These products typically use the same core technology, so they're not necessary. That said, tools like Quizlet or Gemini in google workspace can be highly beneficial since they just make an existing process easier through AI. If"
    },
    {
      question: "Is AI cheating?",
      answer: "It depends on the context. Use it to write your essay - yes ; Use it to study - no. Outside of that its on a \"if it feels like cheating, so its probably cheating\" basis"
    },
    {
      question: "Do I need to use AI to succeed in high school?",
      answer: "No, not at all. Almost all of the current 217 million people who graduated high school in the US graduated without using AI.\n\nBUT - It would be incorrect to say that the world is not shifting towards greater and greater AI implementation, you can gain a hand and increase your impact with AI IF used correctly and you'll be better prepared for the future. The most comprehensive thing you could get is Gemini for google workspace, but check with your school as it's likely you already have access."
    },
    {
      question: "What if AI gives me wrong information?",
      answer: "It will—sometimes confidently. AI makes mistakes, especially with complex topics, recent information, or nuanced questions. Always verify important information, cross-check with reliable sources, and use your critical thinking. If something seems off, it probably is."
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'white',
      padding: '2rem'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        textAlign: 'left',
        fontFamily: 'Inter, sans-serif'
      }}>
        <h1 style={styles.h1}>
         How To Use AI Through<br/>High School
        </h1>
        
        <div>
          <p style={styles.paragraph}>
      AI is here. Don't panic. You're probably already using it—and if you're not, still don't panic. The question isn't whether to use AI in high school, it's how to use it to push the limits of what's possible for you. Here's your guide to figuring that out.
        </p>
          
     
          
  
        </div>
        
        <div style={{
          marginTop: '2rem',
          textAlign: 'left'
        }}>
          <p style={{
            fontSize: '1.3rem',
            background: 'linear-gradient(135deg, #A80C2F, #FFA600)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '1.5rem',
            lineHeight: '1.6',
            fontWeight: '700'
          }}>
            Other resources on this page
          </p>
          
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-start',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => navigate('/tutorials')}
              style={{
                padding: '0.75rem 2rem',
                fontSize: '1.8rem',
                fontWeight: '700',
                fontFamily: 'Inter, sans-serif',
                backgroundColor: 'white',
                background: 'white',
                border: '2px solid #ddd',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = '2px solid transparent';
                e.currentTarget.style.background = 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #A80C2F, #FFA600) border-box';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '2px solid #ddd';
                e.currentTarget.style.background = 'white';
              }}
            >
              <span style={{
                background: 'linear-gradient(135deg, #A80C2F, #FFA600)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: '700'
              }}>
                Tutorials
              </span>
            </button>
            
            <button
              onClick={() => navigate('/prompt-library')}
              style={{
                padding: '0.75rem 2rem',
                fontSize: '1.8rem',
                fontWeight: '700',
                fontFamily: 'Inter, sans-serif',
                backgroundColor: 'white',
                background: 'white',
                border: '2px solid #ddd',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = '2px solid transparent';
                e.currentTarget.style.background = 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #A80C2F, #FFA600) border-box';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '2px solid #ddd';
                e.currentTarget.style.background = 'white';
              }}
            >
              <span style={{
                background: 'linear-gradient(135deg, #A80C2F, #FFA600)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: '700'
              }}>
                Prompt Library
              </span>
            </button>
          </div>
        </div>
        
        <div style={styles.section}>
          <h2 style={styles.h2}>
            Ask It
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              If you think AI could help but you're not sure how, you can always ask: "How can I use you to do X?" It can return a brainstorm of ideas—some will be off the mark, some will be okay, and some will be genuinely useful. It's always worth a try.
            </p>
            
            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <div style={{
                backgroundColor: 'white',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem'
              }}>
                <p style={{
                  margin: 0,
                  fontWeight: '600',
                  color: '#2c3e50',
                  fontSize: '0.9rem',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  Me: "How can I use you to help me prep for the SAT?"
                </p>
              </div>
              
              <div style={{
                backgroundColor: '#f0f0f0',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem'
              }}>
                <p style={{
                  margin: 0,
                  color: '#495057',
                  fontSize: '0.85rem',
                  lineHeight: '1.6',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  AI: "Here are some ways I can help with SAT prep: 1) Generate practice questions similar to ones you got wrong, 2) Explain difficult concepts in math or reading passages, 3) Create a personalized study schedule based on your test date, 4) Review your essay responses and give feedback, 5) Quiz you on vocabulary words with context examples, 6) Break down tricky math problems step-by-step. What area would you like to focus on first?"
                </p>
              </div>
            </div>
            
            <p style={styles.paragraph}>
              Give it a spin with your favored AI product:
            </p>
            
            <div style={{
              display: 'flex',
              gap: '20px',
              marginTop: '1rem'
            }}>
              <a 
                href="https://chat.openAi.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/OpenAI.png" 
                  alt="OpenAI" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
              <a 
                href="https://claude.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/Anthropic.png" 
                  alt="Anthropic" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
            
              <a 
                href="https://gemini.google.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/GoogleGemini.png" 
                  alt="Google Gemini" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
              <a 
                href="https://www.meta.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/MetaAI.png" 
                  alt="Meta AI" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
              <a 
                href="https://grok.x.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/Grok.png" 
                  alt="Grok" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
              <a 
                href="https://chat.deepseek.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/Deepseek.png" 
                  alt="Deepseek" 
                  style={{
                    width: '55px',
                    height: '55px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>    
                <a 
                href="https://copilot.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  cursor: 'pointer',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <img 
                  src="/copilot.png" 
                  alt="copilot" 
                  style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    display: 'block'
                  }}
                />
              </a>
            </div>
          </div>
        </div>
        
        <div style={styles.section}>
          <h2 style={styles.h2}>
            Question It
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              Take everything it outputs with a grain of salt. There are situations where an LLM or AI tool can be tremendously helpful and others where not so much. In specific be very careful with information you get from the Google AI preview thing that shows up at the top when you search something up as those are more likely as of writing this to be blatently wrong.
            </p>
            
            <img 
              src="/googlesearch.png" 
              alt="Google Search AI Preview" 
              style={{
                width: '100%',
                maxWidth: '800px',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                marginTop: '1.5rem'
              }}
            />
          </div>
        </div>
        
        <div style={styles.section}>
          <h2 style={styles.h2}>
            Do's & Don'ts
          </h2>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem'
          }}>
            <div>
              <h3 style={{
                ...styles.h3,
                color: '#28a745'
              }}>
                Do:
              </h3>
              <ul style={{
                ...styles.paragraph,
                paddingLeft: '1.5rem',
                marginBottom: 0
              }}>
                <li style={{ marginBottom: '0.75rem' }}>
                  Ask for ideas, suggestions, or ways to organize your work
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Switch around what product you use, some are better for coding, or integrate better into your life, or just look better. Even though it's creepy, once you find one you like you can work even faster as it can fill in you name on emails etc. 
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Ask for explanations in whatever tone you need—casual, formal, simplified
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Use AI as a brainstorming partner, not a replacement for your thinking
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Ground AI responses in actual course material (paste in your textbook chapter rather than asking broad questions)
                </li>
              </ul>
            </div>
            
            <div>
              <h3 style={{
                ...styles.h3,
                color: '#dc3545'
              }}>
                Don't:
              </h3>
              <ul style={{
                ...styles.paragraph,
                paddingLeft: '1.5rem',
                marginBottom: 0
              }}>
                <li style={{ marginBottom: '0.75rem' }}>
                  Copy paste (you learn nothing)
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Feel like you need to use it for everything, many tasks don't require it.
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Expect every answer to be perfect—some will be way off.
                </li>
                <li style={{ marginBottom: '0.75rem' }}>
                  Rely on content that is exclusively AI generated. For example if you need to study 13th century precolumbian societies do not ask chatGPT for example questions on this broad topic, instead paste in your textbook chapter and go from there, this way your responses are more aligned with school material.
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div id="organization" style={styles.section}>
          <h2 style={styles.h2}>
            Organization
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              One of the easiest steps to succeed in high school is to stay organized. Adding things to your calendar can feel tedious, but you can use CoPilot, Siri, or  Google Gemini which connects directly to your Calendar and say "Hey I have to do the Chem review by saturday 11:59pm". You likely already have access to these options through your phone or school but you can pay also for a similar individual product.
            </p>
            
           
            
            <p style={styles.paragraphLast}>
              You can also edit and create Google Sheets with Gemini, which is invaluable for managing clubs or extracurricular projects.
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <LinkButton href="https://www.youtube.com/watch?v=MIa_282QWMA">
                How to use Google Gemini for Google Calendar
              </LinkButton>
              
              <LinkButton href="https://www.youtube.com/watch?v=QiRUQBwA4EA">
                How to use Google Gemini for Google Sheets
              </LinkButton>
              
              <button
                onClick={() => {
                  navigate('/prompt-library');
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('openPromptCategory', { detail: 'emails' }));
                  }, 100);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#000',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '.5px',
                  transition: 'opacity 0.3s',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: 0,
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Email Templates
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <div id="studying" style={styles.section}>
          <h2 style={styles.h2}>
            Studying
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              Congratulations—you have access to a 24/7 tutor. For foundational topics across most subjects, ChatGPT and other large language models can help tremendously. Ask questions without fear of judgment. There are no dumb questions when you're talking to a computer.
            </p>
            
            <p style={styles.paragraph}>
              But, for complex materials like higher-level physics and calculus, these tools are less reliable. At their core, they're large language models, so when it comes to trickier math it might be worthwhile to leave it on the side lines.
            </p>
            
            <p style={styles.paragraph}>
              For humanities? It's excellent.
            </p>
            
            <p style={styles.paragraph}>
              You can also ask for feedback on your writing before submitting it. You can just paste in an AP rubric, recieve feedback, and edit your work before submitting.
            </p>
            
            <p style={styles.paragraph}>
              For the SAT and ACT, it's great for making more questions just like the ones you keep missing, just paste in the question and ask for new numbers.
            </p>
            
            <p style={styles.paragraph}>
              Another excellent way to use AI is to make flashcards. Now, there are people that benefit a lot from making the cards themselves and in that situation it's better to leave AI out. But, IF you dont fall in that category, making flash cards has never been easier. The best way to do it is - paste your textbook chapter or whatever you want into chatgpt and then tell it "make flashcards for everything in this chapter, output in JSON". While you can in theory skip this and just paste the textbook chapter into quizlet, it more often than not works smoother with this extra step. 
            </p>
            
            <p style={styles.paragraph}>
              Coming back to using chatGPT or Gemini as tutors, go through the content you are trying to learn and make a list of all the things you dont know or need to clarify. 
            </p>
            
            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <p style={{
                fontSize: '1.2rem',
                lineHeight: '1.8',
                marginBottom: '1rem',
                fontStyle: 'italic',
                color: '#6c757d',
                fontFamily: 'Inter, sans-serif'
              }}>
                For example as I write this I have a CSA test tommorrow morning, and I need to clarify Math.random().
              </p>
              
              <div style={{
                backgroundColor: 'white',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem'
              }}>
                <p style={{
                  margin: 0,
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: '#2c3e50',
                  fontSize: '0.9rem',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  Me: "How to use Math.random() in Java?"
                </p>
              </div>
              
              <div style={{
                backgroundColor: '#f0f0f0',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem'
              }}>
                <p style={{
                  margin: 0,
                  color: '#495057',
                  fontSize: '0.85rem',
                  lineHeight: '1.6',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  AI: "Math.random() returns a double between 0.0 (inclusive) and 1.0 (exclusive). To get random integers in a range, use: (int)(Math.random() * range) + min. For example, (int)(Math.random() * 10) gives 0-9."
                </p>
              </div>
              
              <div style={{
                backgroundColor: 'white',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem'
              }}>
                <p style={{
                  margin: 0,
                  fontWeight: '600',
                  color: '#2c3e50',
                  fontSize: '0.9rem',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  Me: "If I need from 32-54, is the 54 included in like the (int)(Math.random()*22+32)?"
                </p>
              </div>
              
              <div style={{
                backgroundColor: '#f0f0f0',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem'
              }}>
                <p style={{
                  margin: 0,
                  color: '#495057',
                  fontSize: '0.85rem',
                  lineHeight: '1.6',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  AI: "No, 54 is not included. The formula should be (int)(Math.random()*23+32) to include both 32 and 54. The range is (max - min + 1), so (54 - 32 + 1) = 23. This gives you 32-54 inclusive."
                </p>
              </div>
              
              <p style={{
                fontSize: '1.2rem',
                lineHeight: '1.8',
                marginBottom: 0,
                fontStyle: 'italic',
                color: '#6c757d',
                fontFamily: 'Inter, sans-serif'
              }}>
                And now I know Math.random().
              </p>
            </div>
            
            <p style={styles.paragraph}>
              You dont have to be perfect, some people literally ask:
            </p>
            
            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <div style={{
                backgroundColor: 'white',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.75rem'
              }}>
                <p style={{
                  margin: 0,
                  fontWeight: '600',
                  color: '#2c3e50',
                  fontSize: '0.9rem',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  Me: "Explain integrals as if I was your bro"
                </p>
              </div>
              
              <div style={{
                backgroundColor: '#f0f0f0',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                padding: '1rem'
              }}>
                <p style={{
                  margin: 0,
                  color: '#495057',
                  fontSize: '0.85rem',
                  lineHeight: '1.6',
                  fontFamily: '"Space Mono", monospace'
                }}>
                  AI: "Yo bro, so integrals are basically the opposite of derivatives, right? Think of it like this - if derivatives tell you the slope at any point, integrals tell you the AREA under the curve. So if you're driving and your speedometer shows your speed (derivative), the integral would be your total distance traveled. You're literally just adding up all those tiny moments. The ∫ symbol? That's just a fancy 'S' for 'Sum'. Pretty sick once you get it."
                </p>
              </div>
            </div>
            
            <p style={styles.paragraph}>
              And it actually works.
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
              marginTop: '1.5rem'
            }}>
              <button
                onClick={() => {
                  navigate('/prompt-library');
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('openPromptCategory', { detail: 'studying' }));
                  }, 100);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#000',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '.5px',
                  transition: 'opacity 0.3s',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: 0,
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Study Prompts
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
              
              <button
                onClick={() => {
                  navigate('/prompt-library');
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('openPromptCategory', { detail: 'sat-act' }));
                  }, 100);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#000',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '.5px',
                  transition: 'opacity 0.3s',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: 0,
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                SAT | ACT Prompts
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <div id="extracurricular" style={styles.section}>
          <h2 style={styles.h2}>
            Extracurricular Activities
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              Need an Instagram post for your club? Generate one. 
            </p>
            
            <p style={styles.paragraph}>
              Need a logo? Generate one. 
            </p>
           <p style={styles.paragraph}>
              Need to create a website? Generate one.
            </p>
            
              <p style={styles.paragraph}>
             None of these will be particularly good or world class, but its a start, a base to iterate off of. With Canva, Wix, GoDaddy, Gemini, and all of the thousands of tools available, leaving an impact has never been easier, beacuse all of the jargon can be more or less automated. Use the funky looking logo GPT spits out and then when you get super successfull someone may reach out and be like "hey, what's with your logo? I'll make you a free one".
            </p>
            
            <p style={styles.paragraph}>
              Even for more formal documents like operating agreements, bylaws, or terms of service for an LLC or nonprofit, you can draft these with AI and then have a lawyer review and edit them, potentially saving hundreds or thousands of dollars.
            </p>
            
            <p style={styles.paragraph}>
              Learn outside of school. If something interests you, there's never been a better time to go down a rabbit hole. With AI as an assistant, tutor, and guide, the barriers to entry have never been lower.
            </p>
            
            <p style={styles.paragraph}>
              If you need to write emails for research opportunities or internships, AI can help edit your tone or fix grammar—just ensure the final version sounds like you, not like an overly formal AI with fancy em dashes.
            </p>
            
            <p style={styles.paragraphLast}>
              You can also use Gemini to create Google Forms for surveys, club attendance tracking, event RSVPs, and more. Instead of manually building forms from scratch, simply describe what you need and let AI generate the entire form structure for you.
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <LinkButton href="https://www.wix.com">
                Making a website with Wix
              </LinkButton>
              
              <LinkButton href="https://gemini.google.com">
                Making a website with Gemini
              </LinkButton>
              
              <LinkButton href="https://support.google.com/docs/answer/15259015?hl=en">
                Create Google Forms with Gemini
              </LinkButton>
              
              <button
                onClick={() => {
                  navigate('/prompt-library');
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('openPromptCategory', { detail: 'extracurricular' }));
                  }, 100);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#000',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '.5px',
                  transition: 'opacity 0.3s',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: 0,
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Extracurricular Prompts
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <div id="applying-to-college" style={styles.section}>
          <h2 style={styles.h2}>
            Applying To College
          </h2>
          
          <div>
            <p style={styles.paragraph}>
              Don't write your essays with AI. Admissions officers can tell instantly when an essay is AI-generated rather than student-written without needing to touch GPT-Zero, remember they have read litteral thousands of essays. Even when correcting grammar or asking for thoughts, make sure the edits don't overpower your voice or influence your writing too heavily.
            </p>
            
            <p style={styles.paragraph}>
              That said, there are smart ways to use AI during the application process. You can ask Gemini to set up a Google Sheet tracking all your schools, required essays, and deadlines.
            </p>
            
            <p style={styles.paragraphLast}>
              Here's an interesting approach: input your entire application profile into ChatGPT and ask, "You are three admissions officers—one rooting for me, one neutral, and one skeptical. What would the skeptical one say?" This can help you identify gaps in how you're presenting yourself and ensure your full personality comes through.
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <button
                onClick={() => {
                  navigate('/prompt-library');
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('openPromptCategory', { detail: 'applying-to-college' }));
                  }, 100);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#000',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  letterSpacing: '.5px',
                  transition: 'opacity 0.3s',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: 0,
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                College Application Prompts
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <div style={styles.section}>
          <div 
            onClick={() => navigate('/prompt-library')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '1rem',
              cursor: 'pointer',
              transition: 'opacity 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            <h2 style={styles.h2}>
              Prompt Library
            </h2>
            <ArrowRight size={32} color="#2c3e50" />
          </div>
        </div>
        
        <div id="faq" style={{
          ...styles.section,
          padding: '2rem',
          border: '5px solid transparent',
          background: 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #00FFFF 0%, #E3D700 50%, #5E00E3 100%) border-box',
          borderRadius: '24px'
        }}>
          <h2 style={styles.h2}>
            Frequently Asked Questions
          </h2>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
            {faqs.map((faq, index) => (
              <div key={index}>
                <button
                  onClick={() => toggleFAQ(index)}
                  style={{
                    width: '100%',
                    padding: '1.5rem 0',
                    border: 'none',
                    background: 'none',
                    textAlign: 'left',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    ...styles.h3,
                    margin: 0
                  }}
                >
                  {faq.question}
                  {openFAQ === index ? (
                    <ChevronUp size={24} color="#2c3e50" />
                  ) : (
                    <ChevronDown size={24} color="#2c3e50" />
                  )}
                </button>
                
                {openFAQ === index && (
                  <div style={{
                    paddingBottom: '1.5rem',
                    ...styles.paragraph,
                    marginBottom: 0
                  }}>
                    {faq.answer.split('\n\n').map((paragraph, pIndex) => (
                      <p key={pIndex} style={{ marginBottom: '1rem' }}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
                
                {index < faqs.length - 1 && (
                  <div style={{
                    height: '1px',
                    backgroundColor: '#ddd',
                    margin: '0'
                  }}></div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        <div style={{
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: '1px solid #ddd',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '1rem',
            color: '#6c757d',
            fontStyle: 'italic'
          }}>
            Created by Rodrigo Duran, with AI
          </p>
        </div>
        
      
      </div>
    </div>
  );
};

export default Home;
